<template>
    <article class="price-item">
        <h3 class="price-item__title">{{lessonType.title}}</h3>

        <form action="/" class="price-select-form price-select-form-js" @submit.prevent="bindSelect">
            <label class="label-select subtype-select">
                <select name="teacher" v-model="currentTeacher">
                    <option value="russian">Русскоязычный преподаватель</option>
                    <option value="foreign">Носитель языка</option>
                </select>
            </label>

            <FormatSelect v-model="currentFormat"></FormatSelect>

            <label class="label-select">
                <select name="count" v-model="currentTariff">
                    <option v-for="(tariff, key) in tariffs"
                            :key="key"
                            :value="key"
                    >{{tariff.title}}</option>
                </select>
            </label>

            <div class="price-select-form__bottom">
                <transition name="fade" mode="out-in">
                    <div class="price-item__price" :key="currentTeacher + '_' + currentFormat + '_' + currentTariff">
                        <div class="price-old" v-if="currentTariffPrice.price_old">{{currentTariffPrice.price_old|price}} ₽</div>
                        <div class="price">{{priceText}}</div>
                    </div>
                </transition>


                <button class="btn btn-light-green btn-lg price-record-btn">Оплатить</button>
            </div>
        </form>
    </article>
</template>

<script>
  import FormatSelect from './FormatSelect';

  export default {
    name: 'IndividualLessonPrices',

    components: {
      FormatSelect,
    },

    props: {
      lessonType: {
        type: Object,
        required: true,
      },
    },

    data(){
      return {
        currentTeacher: 'russian',
        currentFormat: 'distance',
        currentTariff: 0,
      };
    },

    computed: {
      tariffs(){
        return this.lessonType.tariffs[this.currentFormat];
      },

      currentTariffPrice(){
        return this.lessonType.prices[this.currentTeacher][this.currentFormat][this.currentTariff];
      },

      priceText(){
        return formatPrice(this.currentTariffPrice.price) + ' ₽ ' + this.currentTariffPrice.subtext;
      },
    },

    watch: {
      currentFormat(){
        this.currentTariff = 0;
      },
    },

    methods: {
      bindSelect(){
       openPaymentForm({
         lessonType: this.lessonType.id,
         teacher: this.currentTeacher,
         format: this.currentFormat,
         tariff: this.currentTariff,
       });
      },
    },
  };
</script>

<style scoped>

</style>